// Where this build is running, resolved once from the hostname.
//
// Deliberately not NODE_ENV: every deployed build is a production build, so
// NODE_ENV cannot tell the dev site from the prod one. public-tools-js shipped
// the Production PostHog key to its dev site for exactly that reason.
//
// The API base URL and the analytics project are both derived from this so they
// cannot drift apart — pointing the widget at a dev backend while reporting to
// the production consumer project would be worse than either alone.

export const ENVIRONMENTS = {
  LOCAL: 'local',
  VM: 'vm',
  DEV: 'dev',
  PROD: 'prod',
};

// booking.cinch.io is the host real traffic uses: the install snippet, the QR
// link (QR_BOOKING_BASE_URL) and the Reserve with Google feeds all point there.
// scheduler.prod.aws.cinch.io is the deployment bucket's own name and serves
// the identical build, so both are production.
const PROD_HOSTS = ['booking.cinch.io', 'scheduler.prod.aws.cinch.io'];
const DEV_HOST = 'scheduler.dev.aws.cinch.io';

const hostname = () => (typeof window !== 'undefined' ? window.location.hostname : '');

// `scheduler.<developer>.vm.cinch.io` pairs with `be.<developer>.vm.cinch.io`.
// Matched by shape rather than by name so a new developer box needs no edit here.
const vmDeveloper = (host) => {
  const match = /^scheduler\.([^.]+)\.vm\.cinch\.io$/.exec(host);
  return match ? match[1] : null;
};

export const resolveEnvironment = (host = hostname()) => {
  if (PROD_HOSTS.includes(host)) return ENVIRONMENTS.PROD;
  if (host === DEV_HOST) return ENVIRONMENTS.DEV;
  if (vmDeveloper(host)) return ENVIRONMENTS.VM;
  if (host === 'localhost' || host === '127.0.0.1') return ENVIRONMENTS.LOCAL;
  // An unrecognised host is treated as production for the API, so an unknown
  // deployment still serves working bookings. Analytics makes the opposite
  // choice — see posthog.js.
  return ENVIRONMENTS.PROD;
};

export const resolveApiBaseUrl = (host = hostname()) => {
  if (process.env.REACT_APP_API_URL) return process.env.REACT_APP_API_URL;

  const developer = vmDeveloper(host);
  if (developer) return `https://be.${developer}.vm.cinch.io`;

  switch (resolveEnvironment(host)) {
    case ENVIRONMENTS.LOCAL:
      return 'http://localhost:8000';
    case ENVIRONMENTS.DEV:
      return 'https://engine-dev.cinch.io';
    default:
      return 'https://engine.cinch.io';
  }
};

export const isProdHost = (host = hostname()) => PROD_HOSTS.includes(host);
